export const publicPaths = {
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/admin/forgot-password',
  NEW_PASSWORD: '/admin/reset-password',
  SETUP_PASSWORD: '/admin/setup-password',
  CHECK_EMAIL: '/check-email',
  UNAUTHORIZED: '/unauthorized',
};
